import React from "react";
import { connect } from "react-redux";
import Layout from "../../components/layout/Layout";
import ProductCatalog from "../../components/products/ProductCatalog";

const CartPage = ({ pedido }) => {
    return (
      <Layout>
          <ProductCatalog pedidoId={pedido} />
      </Layout>
    );
}

const mapStateToProps = state => ({
    pedido: state.Solicitud.pedido
});

export default connect(mapStateToProps)(CartPage);